<template>
  <div class="page">
    <!--轮播图-->
    <div v-if="bannerList&&bannerList.length>0">
      <van-swipe class="my-swipe" :autoplay="6000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in bannerList" :key="index" >
          <img @click="goDetail(item.noticeId)" class="m-ouc" :src="item.coverUrl" alt="">
          <div v-if="item.coverTitle" class="m-tit">
            <div>{{item.coverTitle}}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--类容-->
    <div class="m-content">
      <p class="m-title">{{titleName}}</p>
      <!--表单-->
      <van-form @submit="onSubmit">
        <div class="x-input-no x-bottom-15">
          <van-field
              v-model.trim="form.number"
              placeholder="请输入证件号码"
              :rules="[{ required: true, message: '' }]"
          />
        </div>
        <div class="x-input-no">
          <van-field
              class="hidden"
              v-model.trim="form.password"
              placeholder="请输入密码"
              :maxlength="23"
              :rules="[{ required: true, message: '' }]"
          />
        </div>
        <p class="m-pass x-color-999 x-font-12" ><span @click="$router.push('/blackPass')">忘记密码</span></p>

        <van-button block class="x-btn-log m-btn" native-type="submit">
            登录
        </van-button>
      </van-form>
    </div>
    <!--底部-->
    <div v-if="showRegister!=0" class="m-footer">
      <p v-if="showRegister==1" class="x-font-color" @click="goTo('/register')">注册用户</p>
      <p v-if="showRegister==2" class="x-font-color" @click="goTo('/applyRegister')">申请注册</p>
    </div>
    <!--弹出通知框-->
    <van-popup v-model="isShow" round get-container="body" :close-on-click-overlay="false">
      <div class="m-popup">
        <div class="m-title">{{topObj.topicTitle}}</div>
        <div class="m-des ql-editor" v-html="topObj.topicText"></div>
        <div class="m-chose">
          <p @click="goLook()" :style="this.downTime>0 ? 'color:#E7E7E7' : ''">{{topObj.topicButton}}<span style="color: #2B6CF9;font-weight: bold">{{downTime>0 ? `(${downTime})` : ''}} </span></p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import isBetween from "dayjs/plugin/isBetween";
  export default {
    components: {},
    data () {
      return {
        isShow:false,
        form:{
          number:'',
          password:'',
        },
        titleName:'',
        bannerList:[],
        showRegister:'',
        times: null,
        topObj:{},
        downTime:'',
        timeOnOff:0,
        isOpen:false,
      }
    },
    created () {
      window.localStorage.clear()
      window.sessionStorage.clear()
      this.getTitle()
      this.getBanner()
    },
    methods: {
      ...mapMutations({
        SET_USER_KEY: 'user/setUserKey',
      }),
      onSubmit(){
        let msg = new FormData()
        msg.append('userName', this.form.number);
        msg.append('pwd', this.form.password);
        this.http.postRequest({
          headers: {'Content-Type': 'multipart/form-data'},
          url:'app/user/login',
          msg:msg,
          special:true,
          success:(res)=>{
            window.localStorage.setItem('token',res.data&&res.data.token ? res.data.token : '')
            if(res.data.p==='0'){
              this.$router.push('/bindPhone')
            } else {
              this.getInfo() 
            }
          }
        }).then((res)=>{
          if(res.code==500&&res.data){
            let obj = ''
            if((typeof res.data)=='object'){
              obj =  res.data
            } else {
              obj =  JSON.parse(res.data)
            }
            if(obj.auditStatus==0){
              this.$router.push('/applySuccess')
            }else if(obj.auditStatus==2){
              this.$store.state.info.applyInfo = obj
              this.$router.push('/applyInfo')
            }
          }else {
            if(res.code!=200){
              this.utils.toastNone(res.msg||res.code)
            }
          }
        })
      },
      goTo(i){
        if(this.timeOnOff==1&&i=='/register'||this.timeOnOff==1&&i=='/applyRegister'){
          if(!this.isOpen){
            this.utils.toastNone('不在注册时间范围内，无法注册！')
            return
          }
        }
        this.$router.push({
          path:i
        })
      },
      getTitle(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.timeOnOff = res.data.timeOnOff
            if(this.timeOnOff==1){
              console.log('ss',520)
              this.dayjs.extend(isBetween)
              const now = this.dayjs();
              let regTimeStart = this.dayjs(res.data.regTimeStart);
              let regTimeEnd =  this.dayjs( res.data.regTimeEnd);
              let isBetweens = now.isBetween(regTimeStart, regTimeEnd);
              this.isOpen = isBetweens
//              console.log('ssss',isBetweens); // true or false
            }
            this.topObj = {
              topOnOff:res.data.topOnOff,
              topicButton:res.data.topicButton,
              topicText:res.data.topicText,
              topicTime:res.data.topicTime,
              topicTitle:res.data.topicTitle,
            }
            this.titleName = res.data.studentTitle
            this.showRegister = res.data.showRegister
            //弹窗倒计时
            if(res.data.topOnOff==1){
              this.isShow = true
              this.downTime =  this.topObj.topicTime
              this.times = setInterval(()=>{
                if(this.downTime>0){
                  this.downTime = this.downTime-1
                } else {
                  this.downTime = 0
                  clearInterval(this.times)
                }
              },1000)
            }
          }
        })
      },
      getBanner(){
        this.http.getRequest({
          url:'app/userInfo/list',
          msg:{noticeType:1,},
          success:(res)=>{
            this.bannerList = res.rows
          }
        })
      },
      //获取个人信息
      getInfo(){
        this.http.postRequest({
          url:"app/user/getUserInfo",
          msg:{},
          success:(res)=>{
            this.SET_USER_KEY({key:'userInfo', value: res.data ? res.data : ''})
            if(this.utils.isWeixin()){
              this.isOauth()
            } else {
              this.$router.replace({
                path:'/examHome'
              })
            }
          }
        },true)
      },
      goDetail(i){
        this.$router.push({
          path:'/newsDetail',
          query:{
            noticeId:i
          }
        })
      },
      isOauth(){
        this.http.getRequest({
          url:'app/exam/queryWxAccountDict',
          msg:{},
          special: true,
          success:(res)=>{
            if(res.data){
              this.getWxSet(res.data)
            } else {
              this.$router.replace({
                path:'/examHome'
              })
            }
          },
          fail:(res)=>{
            this.$router.replace({
              path:'/examHome'
            })
          }
        })
      },
      getWxSet(payUrl){
        if(!payUrl){
          this.utils.toastNone('缺少授权地址！')
        }
        this.http.getRequest({
          url:'app/oAuth/makeAccessCodeURL',
          msg:{},
          success:(res)=>{
            let appid = res.data.appid
            let scope = res.data.scope
            let state = res.data.state
            let originUrl = window.location.origin
            window.location.href = `${payUrl}/autoPage?appid=${appid}&scope=${scope}&state=${state}&originUrl=${originUrl}`
          }
        })
      },
      goLook(){
        if(this.downTime>0){ return }
        this.isShow = false
      },
    },
    mounted () {

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    .my-swipe{
      width: 375px;
      height: 180px;
      /deep/.van-swipe__indicator{
        width: 18px!important;
        height: 3px!important;
        border-radius: 0!important;
      }
      .van-swipe-item {
        color: #fff;
        font-size: 20px;
        /*line-height: 150px;*/
        text-align: center;
        background: linear-gradient(90deg, #3E8DF6 0%, #3A5AF5 100%);
      }
      .m-ouc{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .m-tit{
        width: 100%;
        background: rgba(255, 255, 255, 0.3);
        position: absolute;
        bottom: 0;
        z-index: 1000;
        backdrop-filter: blur(5px);
        padding: 5px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        >div{
          font-size: 14px;
          color: #ffffff;
          -webkit-line-clamp: 2; // 设置两行文字溢出
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 20px;
        }
      }
    }
    .m-content{
      padding: 25px 28px;
      .m-title{
        text-align: center;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .hidden{
        /deep/.van-field__value {
          -webkit-text-security: disc;
          text-security: disc;
        }
      }
      .m-pass{
        text-align: right;
        margin-top: 18px;
      }
      .m-btn{
        margin-top: 30px;
      }
    }
    .m-footer{
      margin-top: 23px;
      font-size: 15px;
      display: flex;
      justify-content: center;
      gap:70px;
    }
  }
  .m-popup {
    width: 300px;
    /*mim-height: 145px;*/
    background: #ffffff;
    font-size: 15px;
    .m-title {
      padding: 4px 8px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      height: 53px;
      line-height: 20px;
      max-height: 40px;
      -webkit-line-clamp: 2; // 设置两行文字溢出
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .m-des {
      padding: 10px 20px 20px 20px;
      border-bottom: 1Px solid #E7E7E7;
      line-height: 20px;
      max-height: 60vh;
      overflow-y: auto;
    }
    .m-chose {
      display: flex;
      align-items: center;
      > p {
        flex: 1;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: bold;
        color: #2B6CF9;
      }
      > p:nth-child(2) {
        color: #2B6CF9;
        border-left: 1Px solid #E7E7E7;
      }
    }
  }

  .van-popup--center.van-popup--round {
    border-radius: 4px !important;
  }
</style>

